import {
  FAKE,
  fakeDelay,
  getFakeKycId,
  markFakeKycApproved,
  readFakeKycProfile,
  saveFakeKycProfile,
} from "../fake";
import type { UsKycProfile, UsKycStatus } from "../types";

/**
 * 美国合规 KYC（供应商托管那套）。
 *
 * 与 src/api/kyc.ts 是两回事：那份是 LatAm/PH 的自填资料 + 后台人审
 * （/api/kyc/one|status|persist），这份是「跳供应商验证页 + 回调写状态」。
 *
 * 【假数据】后端还没有这三个接口，先按 fake.ts 返回。接真接口时分别换成：
 * - getUsKycStatus  → POST /api/kyc/us_status，返回 kyc_age / kyc_id / kyc_poa
 * - saveUsKycProfile→ POST /api/kyc/us_profile，提交 INFO 表单
 * - getUsKycProfile → 取已提交的资料，供 Re-verify 回填表单
 * - 跳转用的「取验证页地址」目前没写（UsKycGateDialog 里那一步是注释掉的），
 *   接的时候补一个打 POST /api/kyc/verify_id 的函数
 * 状态查不到时按 fail-open 当作已认证，沿用 Recharge.tsx 里
 * 「出错时默认已认证，避免误弹窗」的既有取舍。
 */
export const getUsKycStatus = (): Promise<UsKycStatus> =>
  fakeDelay({
    kycAge: FAKE.kycId === 0 ? 0 : 1,
    kycId: getFakeKycId(),
    kycPoa: FAKE.kycPoa,
  });

/** 提交 INFO 表单。返回是否成功，失败原因走调用方的 Message 提示。 */
export const saveUsKycProfile = (profile: UsKycProfile): Promise<boolean> => {
  saveFakeKycProfile(profile);
  return fakeDelay(true);
};

/**
 * 读回已提交的 INFO 资料，用于表单回填（Re-verify 时不让用户重填七个字段）。
 * 没提交过返回 null。
 *
 * 接真接口时换成后端那条「取已提交资料」的查询（合规文档里对应
 * getApplicantIdInfo / session decision），前端不再自己留一份。
 */
export const getUsKycProfile = (): Promise<UsKycProfile | null> =>
  fakeDelay(readFakeKycProfile());

/**
 * 【假数据专用】把认证状态直接置为通过。
 *
 * 真流程里没有这一步 —— 结果是供应商回调写进后端、前端查出来的，前端不该有写入口。
 * 接真接口时连同 UsKycGateDialog 里注释掉的跳转一起删。
 */
export const fakeApproveUsKyc = (): Promise<void> => {
  markFakeKycApproved();
  return fakeDelay(undefined);
};
